import { useTranslation } from 'react-i18next'

import {
	useCurrenciesQuery,
	useCurrencyScope,
	useSelectedCurrency,
} from '@/entities/currency'

import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from '@/shared/components/ui/select'
import { getCurrencySign } from '@/shared/tools/locale'

const CurrencyLabel = ({ code }: { code: string }) => (
	<span>
		<span className='text-muted-foreground'>{getCurrencySign(code)}</span>{' '}
		{code}
	</span>
)

export const CurrencyPicker = () => {
	const { t } = useTranslation()
	const { data } = useCurrenciesQuery()
	const selected = useSelectedCurrency()
	const [, setCurrency] = useCurrencyScope()
	const currencies = data?.currencies ?? []

	return (
		<Select
			value={selected ?? ''}
			onValueChange={setCurrency}
			disabled={currencies.length <= 1}
		>
			<SelectTrigger
				size='sm'
				aria-label={t('currency_picker_label')}
				data-testid='currency-picker-trigger'
			>
				<SelectValue>
					{selected && <CurrencyLabel code={selected} />}
				</SelectValue>
			</SelectTrigger>
			<SelectContent position='popper'>
				{currencies.map((code) => (
					<SelectItem
						key={code}
						value={code}
						data-testid={`currency-picker-option-${code}`}
					>
						<CurrencyLabel code={code} />
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	)
}
